import { 
  QuestionMarkCircleIcon,
  CurrencyDollarIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import { H5 } from '../ui/Typography';

interface QuickLinksProps {
  openSection: string | null;
  setOpenSection: (section: string | null) => void;
}

const sections = [
  { id: 'getting-started', title: 'Getting Started', icon: QuestionMarkCircleIcon },
  { id: 'investment-process', title: 'Investment Process', icon: CurrencyDollarIcon },
  { id: 'technical', title: 'Technical & Security', icon: ShieldCheckIcon },
];

export default function QuickLinks({ openSection, setOpenSection }: QuickLinksProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
      {sections.map((section) => (
        <button
          key={section.id}
          onClick={() => setOpenSection(section.id)}
          className={`p-4 rounded-lg transition-all duration-200 ${
            openSection === section.id
              ? 'bg-primary text-white shadow-lg'
              : 'bg-white text-primary hover:bg-gray-50'
          }`}
        >
          <section.icon className={`w-6 h-6 mx-auto mb-2 ${
            openSection === section.id ? 'text-white' : 'text-secondary'
          }`} />
          <H5 className={openSection === section.id ? 'text-white' : 'text-primary'}>
            {section.title}
          </H5>
        </button>
      ))}
    </div>
  );
}